import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MediaList from './mediaList';
import { ToastContext } from '@weezevent/nacre';
import OrganizationSettings from '../../models/organizationSettings';

export default function OrganizationMediaList({ organization, medias: _medias }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [medias, setMedias] = React.useState(_medias);

    const updateImage = React.useCallback(
        (image, media, type) => {
            let tmpMedias = { ...medias };
            if (!image) {
                delete tmpMedias[type];
            } else {
                media.path = image.path;
                media.type = type;
                media.url = image.url;
                tmpMedias[type] = media.toAPI();
            }
            let organizationSettings = new OrganizationSettings();
            organizationSettings.medias = tmpMedias;
            organizationSettings
                .save({
                    organizationId: organization.pk
                })
                .then(() => {
                    toast.success(t('ticket.partners.medias.success.update'));
                    setMedias(tmpMedias);
                })
                .catch(e => {
                    toast.error(t('ticket.partners.medias.error.update'));
                });
        },
        [toast, organization, medias, setMedias]
    );

    return (
        <>
            <MediaList organization={organization} medias={medias} updateImage={updateImage} />
        </>
    );
}

OrganizationMediaList.propTypes = {
    organization: PropTypes.object.isRequired,
    partnerId: PropTypes.string,
    medias: PropTypes.array.isRequired
};
